function loginInit() {
    $.validator.unobtrusive.parse($('form'));
    triggerLocaleSwitch();
    $('#UserName').trigger("focus");
}

function checkInput(e) {
    var keyCode = e.keyCode;
    var returnValue = true;

    // prevent < and >
    if (e.shiftKey && (keyCode === 188 || keyCode === 190)) {
        returnValue = false;
    }

    return returnValue;
}

function checkSubmit() {
    var userName = $('#UserName');
    var password = $('#Password');

    userName.value = stripChars(userName.val());
    password.value = stripChars(password.val());

    return true;
}

function stripChars(val) {
    val = val.replace(/>/gi, '');
    val = val.replace(/</gi, '');
    return val;
}

function triggerLocaleSwitch() {
    $('#cultureSelection').not('[data-processed="true"]').each(function () {
        var that = $(this);
        var localeURL = $('.loginForm').attr('data-locale-url');
        currentLocale = that.val();
        that.on('change', function () {

            var dataToSend = { "newLocale": that.val(), "returnUrl": "@rtnUrl" };

            $.ajax({
                url: localeURL,
                type: 'POST',
                dataType: 'html',
                data: dataToSend,
                success: function () {
                    location.reload();
                },
                error: function (e) {
                    alert(e.responseText);
                }
            });
        });
    });
}

function logOff(url) {
    trs.ui.dialogBoxConfirm(null, trs.resources.scriptResource.getValue('ConfirmLogOff'), function () {
        window.location.replace(url);
    });
}

function certificateLogin(certificateLoginUrl, returnUrl) {

    $.ajax({
        url: certificateLoginUrl,
        success: function () {
            window.location = returnUrl;
        }
    });
}